import { capitalize } from 'lodash';
import React from 'react';
import { ProgressBar } from 'react-progressbar-fancy';
import { Link } from 'react-router-dom';
import useElemSize from '../../hooks/useElemSize';
import useMain from '../../hooks/useMain';
import userRank from '../../utils/userRank';
import Image from '../common/image';
import MaxCapModal from './maxcapModal';

const Summary = () => {
	const { userData, initData, theme } = useMain();
	const [ref] = useElemSize('summary');
	const rank = userRank(userData, initData);
	const totalUsedMaxCap = userData.MMIUsedMaxCap + userData.totalCardsUsedMaxCap;

	const score = ((totalUsedMaxCap * 100) / userData.maxCap).toFixed(2);
	const maxCapMode =
		totalUsedMaxCap / userData.maxCap >= initData.maxCapAlert ? 'alert' : `normal_${theme}`;

	const progressBarColors = {
		normal_light: ['#d07df6', '#ace4fd'],
		normal_dark: ['#87D900', '#1D8F00'],
		alert: ['#ff0000', '#920b0b'],
	};

	return (
		<div
			ref={ref}
			id='userSummary'
			className='card contentsCard'>
			<div className='card-body'>
				<div className='text-center mb-2 d-none d-md-block'>
					<Link to='/'>
						<Image
							className='w-75'
							fileName={`logo/${theme}.webp`}
						/>
					</Link>
				</div>
				<div className='mb-2 d-block d-md-none'>
					{rank && rank.rank !== 'none' && (
						<>
							<div className='d-flex justify-content-evenly align-items-center'>
								<div>
									<b>{rank.title}</b>
								</div>
								<Image
									fileName={`ranks/rank_${initData.userRanks.indexOf(rank)}.svg`}
									height='55px'
								/>
							</div>
							<hr className='my-1' />
						</>
					)}
				</div>

				<div className='d-flex align-items-center justify-content-evenly'>
					<div className='d-flex flex-xxl-row flex-column align-items-center'>
						<div>
							<Image
								height='30px'
								fileName='icons/coins/bcn.png'
								className='mx-1'
							/>
						</div>
						<div className='text-center'>
							<div>
								<span style={{ fontSize: '11px' }}>{initData.bcn_price}</span>
								<span
									className='ms-1'
									style={{ fontSize: '9px' }}>
									trx
								</span>
							</div>
							<div style={{ fontSize: '9px' }}>($ {initData.bcn_price_usd})</div>
						</div>
					</div>

					<div className='d-flex flex-xxl-row flex-column align-items-center'>
						<div>
							<Image
								height='35px'
								fileName='icons/coins/tim.png'
							/>
						</div>
						<div className='text-center'>
							<div>
								<span style={{ fontSize: '11px' }}>{initData.tim_price}</span>
								<span
									className='ms-1'
									style={{ fontSize: '9px' }}>
									trx
								</span>
							</div>
							<div style={{ fontSize: '9px' }}>($ {initData.tim_price_usd})</div>
						</div>
					</div>
				</div>

				<hr className='my-2' />
				<div className='row g-0 align-items-center'>
					<div className='col-2 text-center'>
						<Image
							fileName={`diamonds/${userData.currentCard.name}.webp`}
							className='w-100'
						/>
					</div>
					<div className='col text-center summaryEmail fs-7'>
						<div className='centerAll'>
							<div>{userData.bemchain.uid}</div>
							<Image
								className='ms-1'
								fileName={`verification/${userData.verificationLevel}.svg`}
								height='15px'
							/>
						</div>
						<div>{userData.email}</div>
						<div className='centerAll'>
							{userData.class !== 'none' && (
								<div className='fw-bold'>{capitalize(userData.class)}</div>
							)}
							{userData.class === 'planner' && (
								<div className='ms-2 text-decoration-underline'>
									Flash: <span className='fw-bold'>{userData.flash.length}</span>{' '}
									times
								</div>
							)}
						</div>
					</div>
					<div className='col-2 text-center'>
						<Image
							fileName={`diamonds/mmi_${userData.mmi.isActive}.webp`}
							className='w-100'
						/>
					</div>
				</div>
				{userData.isUserActive && (
					<ProgressBar
						className='my-2 fancy'
						label={
							<div className='d-flex align-items-center'>
								<span className='me-1'>Total Max Cap</span> <MaxCapModal />
							</div>
						}
						primaryColor={progressBarColors[maxCapMode][0]}
						secondaryColor={progressBarColors[maxCapMode][1]}
						score={Number(score)}
					/>
				)}
			</div>
		</div>
	);
};

export default Summary;
